// The person box takes an id or an email; anything that isn't a whole id is looked up as an email. An id may be wrapped
// in a matching pair of braces and must have all four hyphens or none, the forms the API's Guid binding accepts.
export function splitIdOrEmail(valueP: string | null): { id?: string, email?: string } {
  const value = (valueP ?? '').trim();
  if (!value) {
    return {};
  }
  const unwrapped = /^\{.*\}$/.test(value) ? value.slice(1, -1) : value;
  const is_id = /^([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}|[0-9a-f]{32})$/i.test(unwrapped);
  return is_id ? {id: unwrapped} : {email: value};
}
